export default "__VITE_ASSET__BN6J3ID2__"